import system from "./system";
import router from "./router";
import msg from "./msg";
import login from "./login";
import home from "./home";
import starting from "./starting";
import my from "./my";
import records from "./records";
import withdraw from "./withdraw";
import deposit from "./deposit";
import vip from "./vip";
import profileItem from "./profileItem";
import paymentMethods from "./paymentMethods";
import gifts from "./gifts";
import wheels from "./wheels";
import web3 from "./web3";

export default {
	system,
	router,
	msg,
	login,
	home,
	starting,
	my,
	records,
	withdraw,
	deposit,
	vip,
	profileItem,
	paymentMethods,
	gifts,
	wheels,
	web3
};
